import { EmailStatus } from "constants/email";

export const getBounceCount = emails =>
  emails.filter(e => Boolean(e) && e.status === EmailStatus.Bounced).length;
export const getErrorCount = emails =>
  emails.filter(e => Boolean(e) && e.status === EmailStatus.Error).length;
